module.exports = __webpack_public_path__ + "static/media/credit_to_pay.c6bc0d45.png";